<template>
	<section>
		<header-simple :title="$t('labels.profile.insurances')" :subtitle="$t('Personal information about the patient.')">
			<!-- <action-button @click="addContact" :title="$t('Add contact')" /> -->
		</header-simple>
	</section>
</template>

<script>
import HeaderSimple from '@/modules/ui/HeaderSimple'
export default {
	name: 'watch-profile-insurances',
	components: {
		HeaderSimple
	},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/watch/profile/watchProfile/WatchProfileInsurances.vue